let $eplanSearchQuery = $('#eplan-search--query');

let eplanSearchMatching = function(force){
    let enable = function($query) {
        return $query.replace(/\w+/g, "+$&");
    }
    let disable = function($query) {
        return $query.replace(/\+\b/g, "");
    }
    let query = $eplanSearchQuery.val();

    if(force) {
        query = enable(disable(query));
    } else {
        query = disable(query);
    }

    $eplanSearchQuery.val(query);
};


$('#eplan-search--exactMatching').on('click', function(e){
    let force = $(this).prop('checked');
    eplanSearchMatching(force);
});

